/* eslint-disable indent */
import 'chartjs-adapter-date-fns';

import React from 'react';
import {
  Card, Col,
  Row, Spinner,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { fetchLiquidContainerReadings, selectCurrentLiquidContainer, selectCurrentLiquidContainerReadings } from '../../../store/slices/liquid-containers-slice';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import DateRangePicker from '../../UI/molecules/DateInput/range-picker';
import { LocationMap } from '../../UI/organisms/Sensors/location-map';
import { SensorChart } from '../../UI/organisms/Sensors/sensor-chart';
import { SummaryTable } from './liquid-summary-table';

export const getDefaultDateRange = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 3);

  return {
    start: d,
    end: new Date(),
  };
};
export function SensorInfo() {
  const fetchStatus = useSelector(
    (state) => state.liquidContainer.fetchLiquidContainerReadings.status,
  );
  const dispatch = useDispatch();
  const currentLiquidContainer = useSelector(selectCurrentLiquidContainer);

  React.useEffect(() => {
    if (currentLiquidContainer?.serialNumber) {
      const range = getDefaultDateRange();
      const arg = {
        serialNumber: currentLiquidContainer.serialNumber,
        range: { start: range.start.toJSON(), end: range.end.toJSON() },
      };
      // eslint-disable-next-line spaced-comment
      dispatch(fetchLiquidContainerReadings(arg));
    }
  }, [currentLiquidContainer]);

  const { summary: summaryData, data: containerReadings, breadcrumbs: breadcrumbsRaw } = useSelector(selectCurrentLiquidContainerReadings);

  const getTimestamp = (dateString) => {
    const dt = new Date(dateString);
    return dt.getTime();
  };
  const dp = (val, element) => {
    return {
      x: getTimestamp(element.readingTime),
      y: val,
    };
  };
  const uniqBy = (a, key) => {
    const seen = {};
    return a.filter((item) => {
      const k = key(item);
      // eslint-disable-next-line no-return-assign, no-prototype-builtins
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  };

  return (
    <div className="container-fluid">
      <Row>
        <Col>
          <Card className="card-primary card-outline" style={{ width: '100%', marginTop: 6 }}>
            <Card.Header>
              <h3 className="card-title">Latest Readings</h3>
            </Card.Header>
            <div className="px-2">
              <SummaryTable />
            </div>
          </Card>
        </Col>
      </Row>
      <DateRangePicker
        defaultValue={getDefaultDateRange()}
        onRangeChanged={(r) => {
          const arg = {
            serialNumber: currentLiquidContainer.serialNumber,
            range: {
              start: r.start.toJSON(),
              end: r.end.toJSON(),
            },
          };
          dispatch(fetchLiquidContainerReadings(arg));
        }}
      />
      {fetchStatus === 'loading' && (
        <Spinner
          animation="border"
          variant="primary"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate (-50%, -50%)',
          }}
        />
      )}
      {fetchStatus !== 'loading' && (
        <>
          <Row>
            <Col>
              <Card className="card-primary card-outline">
                <Card.Header>
                  <h3 className="card-title">Product Sensors</h3>
                </Card.Header>
                <Card.Body>
                  <SensorChart
                    containerReadings={
                      [
                        {
                          label: 'N2 Level',
                          data: containerReadings.filter((x) => x.dN2Level !== 'NaN').map((x) => dp((!Number.isNaN(x.dN2Level) ? x.n2Level : ''), x)),
                        },
                        {
                          label: 'N2 Pressure',
                          data: containerReadings.filter((x) => x.DN2Pressure !== 'NaN').map((x) => dp((!Number.isNaN(x.DN2Pressure) ? x.DN2Pressure : ''), x)),
                        },
                        {
                          label: 'He Level',
                          data: containerReadings.filter((x) => x.DHeLevel !== 'NaN').map((x) => dp((!Number.isNaN(x.DHeLevel) ? x.DHeLevel : ''), x)),
                        },
                        {
                          label: 'He Pressure',
                          data: containerReadings.filter((x) => x.DHePressure !== 'NaN').map((x) => dp((!Number.isNaN(x.DHePressure) ? x.DHePressure : ''), x)),
                        },
                      ]
                    }
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="card-primary card-outline">
                <Card.Header>
                  <h3 className="card-title">Device Sensors</h3>
                </Card.Header>
                <Card.Body>
                  <SensorChart
                    containerReadings={
                      [
                        {
                          label: 'Battery Voltage (V)',
                          data: uniqBy(containerReadings.filter((x) => x.DBatteryLevel !== 'NaN' && !Number.isNaN(x.DBatteryLevel)).map((x) => dp((!Number.isNaN(x.DBatteryLevel) ? x.DBatteryLevel : ''), x)), JSON.stringify),
                        },
                        {
                          label: 'Temperature (F)',
                          data: uniqBy(containerReadings.filter((x) => x.DAmbientTemperature !== 'NaN' && !Number.isNaN(x.DAmbientTemperature)).map((x) => dp((!Number.isNaN(x.DAmbientTemperature) ? x.DAmbientTemperature : ''), x)), JSON.stringify),
                        },
                      ]
                    }
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card className="card-primary card-outline" style={{ width: '100%', height: 600 }}>
                <Card.Header>
                  <h3 className="card-title">Map</h3>
                </Card.Header>
                <Card.Body>
                  <LocationMap
                    assetType="liquid"
                    readings={{
                      summary: summaryData,
                      breadcrumbs: breadcrumbsRaw,
                    }}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </div>

  );
}
